import { render, staticRenderFns } from "./ServiceRequestFilters.vue?vue&type=template&id=938190f2&"
import script from "./ServiceRequestFilters.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestFilters.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestFilters.vue?vue&type=style&index=0&id=938190f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports